import { endpoints, request } from '!core/api';

export const activateUserServices = {
  updateUserByToken: ({ token, salt, hashPassword, otp }) =>
    request.postWebService(endpoints.webservices(`updateUserByToken`), {
      token,
      salt,
      key: hashPassword,
      otp,
    }),
};
